
import { Reducer } from 'interfaces'
import { AdvisorDataState, AdvisorAppState } from 'components/features/coaching/advisorStore/interfaces/state'
import {
  AdvisorsRequestAction,
  ResetAdvisorsRequestStateAction,
  CREATE_ADVISOR_MEETING,
  CANCEL_ADVISOR_MEETING,
  SET_VISIBLE_ADVISORS,
} from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { createEmptyCollection, concatCollections, setItemInCollection, normalize } from 'helpers/normalizeHelpers'
import { GetMeetingAction, MEETINGS_LIST_REQUEST } from 'components/features/coaching/advisorStore/actions/advisorPageActions'
import { createEmptyFetchable, createFetchableReducer } from 'helpers/loadableHelpers'
import { GetMeetingVideoDetailsAction } from 'components/features/coaching/advisorVideoCall/types/actions'
import { KILL_ALL_FLOATING_PANES, KILL_FLOATING_PANES } from 'actions/floatingPanesActions'
import { GetPublicAdvisorAction, GetPublicAdvisorTimeslotsAction } from 'components/features/coaching/advisorStore/actions/publicAdvisorActions'
import { GetTopAdvisorsAction } from 'components/features/coaching/advisorStore/actions/advisorLandingPageActions'
import { Advisor } from 'components/features/coaching/advisor/types/advisor'

export const advisorsReducer: Reducer<AdvisorDataState['advisors']> = (prevState = createEmptyCollection(), action) => {
  switch (action.type) {
    case AdvisorsRequestAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }
      return concatCollections<Advisor, 'uid'>(prevState, action.payload.response.advisors)
    }

    case GetMeetingAction.type:
    case CANCEL_ADVISOR_MEETING:
    case CREATE_ADVISOR_MEETING: {
      if (action.meta !== 'success') {
        return prevState
      }

      return setItemInCollection(prevState, action.payload.response.advisor, 'uid')
    }

    case MEETINGS_LIST_REQUEST: {
      if (action.meta !== 'success') {
        return prevState
      }

      return concatCollections<Advisor, 'uid'>(prevState, action.payload.response.advisors)
    }

    case GetMeetingVideoDetailsAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      if (!action.payload.response.advisor) {
        return prevState
      }
      return setItemInCollection(prevState, action.payload.response.advisor, 'uid')
    }

    case GetPublicAdvisorAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }
      const { rating_breakdown, ...advisor } = action.payload.response
      return setItemInCollection(prevState, advisor, 'uid')
    }

    case GetTopAdvisorsAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return concatCollections(prevState, normalize(action.payload.response, 'uid'))
    }
  }
  return prevState
}

const fetchableReducer = createFetchableReducer<AdvisorDataState['advisorsRequest']['data']>()
export const advisorsRequestReducer: Reducer<AdvisorDataState['advisorsRequest']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case AdvisorsRequestAction.type: {
      return fetchableReducer(prevState, action)
    }
    case ResetAdvisorsRequestStateAction.type: {
      return createEmptyFetchable()
    }
  }
  return prevState
}

export const advisorsPaginationReducer: Reducer<AdvisorDataState['advisorsPagination']> = (prevState = null, action) => {
  switch (action.type) {
    case AdvisorsRequestAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return action.payload.response.advisorsPagination
    }

    case GetPublicAdvisorTimeslotsAction.type: {
      if (action.meta !== 'success' || action.payload.params.flow !== 'profile') {
        return prevState
      }

      return {
        next: null,
        results: [action.payload.params.advisor_uid],
      }
    }
  }
  return prevState
}

const DEFAULT_VISIBLE_ADVISORS = 1
export const advisorsVisibleReducer: Reducer<AdvisorAppState['advisorsVisible']> = (prevState = DEFAULT_VISIBLE_ADVISORS, action) => {
  switch (action.type) {
    case KILL_FLOATING_PANES:
    case KILL_ALL_FLOATING_PANES: {
      return DEFAULT_VISIBLE_ADVISORS
    }

    case SET_VISIBLE_ADVISORS: {
      return action.payload
    }

      return prevState as number
  }
  return prevState
}
